import request from '@/utils/request'

// 查询列表
export function apiScpMrpPlansList (query) {
  return request({
    url: '/scp/scpMrpPlans/list',
    method: 'get',
    params: query
  })
}
// 详情
export function apiScpMrpPlansBasicInformation (id) {
  return request({
    url: `/scp/scpMrpPlans/basicInformation/${id}`,
    method: 'get'
  })
}

// 导出列表
export function apiScpMrpPlansNewExport (data) {
  return request({
    url: '/scp/scpMrpPlans/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiScpMrpPlansUpdate (data) {
  return request({
    url: '/scp/scpMrpPlans',
    method: 'put',
    data: data
  })
}

// 新增
export function apiScpMrpPlansAdd (data) {
  return request({
    url: '/scp/scpMrpPlans',
    method: 'post',
    data: data
  })
}

// 删除
export function apiScpMrpPlansDelete (id) {
  return request({
    url: `/scp/scpMrpPlans/${id}`,
    method: 'delete'
  })
}

// 计划组织-删除
export function apiScpPlanMrpOrganizationsDelete (id) {
  return request({
    url: `/scp/scpPlanMrpOrganizations/${id}`,
    method: 'delete'
  })
}

// 计划组织-修改
export function apiScpPlanMrpOrganizationsUpdate (data) {
  return request({
    url: '/scp/scpPlanMrpOrganizations',
    method: 'put',
    data: data
  })
}

// 计划组织-新增
export function apiScpPlanMrpOrganizationsAdd (data) {
  return request({
    url: '/scp/scpPlanMrpOrganizations',
    method: 'post',
    data: data
  })
}

// 需求源-删除
export function apiScpPlanMrpSchedulesDelete (id) {
  return request({
    url: `/scp/scpPlanMrpSchedules/${id}`,
    method: 'delete'
  })
}

// 需求源-新增
export function apiScpPlanMrpSchedulesAdd (data) {
  return request({
    url: '/scp/scpPlanMrpSchedules',
    method: 'post',
    data: data
  })
}

// 补全SCP净值仓
export function apiScpMrpPlanSubinventoriesRequest (data) {
  return request({
    url: '/scp/scpMrpPlanSubinventories',
    method: 'post',
    data: data
  })
}

// 净值仓-修改
export function apiScpMrpPlanSubinventoriesUpdate (data) {
  return request({
    url: '/scp/scpMrpPlanSubinventories',
    method: 'put',
    data: data
  })
}

// 运行阶段-删除
export function apiScpMrpPlanStagesDelete (id) {
  return request({
    url: `/scp/scpMrpPlanStages/${id}`,
    method: 'delete'
  })
}

// 运行阶段-修改
export function apiScpMrpPlanStagesUpdate (data) {
  return request({
    url: '/scp/scpMrpPlanStages',
    method: 'put',
    data: data
  })
}

// 运行阶段-新增
export function apiScpMrpPlanStagesAdd (data) {
  return request({
    url: '/scp/scpMrpPlanStages',
    method: 'post',
    data: data
  })
}

// 运行阶段-补全SCP运行阶段明细
export function apiScpMrpPlanStagesDetailRequest (data) {
  return request({
    url: '/scp/scpMrpPlanStagesDetail',
    method: 'post',
    data: data
  })
}

// 运行阶段-编辑按钮-保存
export function apiScpMrpPlanStagesDetailUpdate (data) {
  return request({
    url: '/scp/scpMrpPlanStagesDetail',
    method: 'put',
    data: data
  })
}
